import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import cx from 'classnames';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { pushGaStepEvent } from 'actions/loan';
import ThankYouItem from 'components/Credit24/LoanApplication/ThankYou/ThankYouItem';
import Button from 'components/common/Button';
import { CREDIT_APPLICATION_STATE_APPROVED } from 'consts/loan/creditApplicationStates';
import { PRODUCT_TYPES } from 'consts/products';
import { useThankYouContent } from './hooks/useThankYouContent';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  loan: PropTypes.object.isRequired,
  handleReturnLink: PropTypes.func.isRequired,
};

const ThankYouPage = (props) => {
  const { authentication, loan, handleReturnLink } = props;

  const isOcm = useSelector((state) => state.loan.channel === 'OCM-WEB');
  const firstDrawAmount = loan.selectedProduct.firstDrawAmount;
  const isApproved = loan.state === CREDIT_APPLICATION_STATE_APPROVED;
  const isCreditLine = loan.productType === PRODUCT_TYPES.CREDIT_LINE;
  const hasFunds = firstDrawAmount > 0;
  const { emailPending } = authentication;

  const { thankYouItems, thankYouText } = useThankYouContent({
    isOcm, isApproved, isCreditLine, hasFunds, emailPending,
  });

  const isApprovedWithoutFunds = isApproved && !hasFunds;

  useEffect(() => {
    // eslint-disable-next-line react/prop-types
    props.pushGaStepEvent('thank_you');
  }, []);

  let btnOfferSuccessText = 'offer.submit.log_into.self_service';

  if (INCREASE_APP) {
    btnOfferSuccessText = 'offer.submit.goto.selfservice';
  }
  if (isApprovedWithoutFunds) {
    btnOfferSuccessText = 'offer.submit.make_a_draw';
  }
  if (EMBEDDED) {
    btnOfferSuccessText = 'offer.submit.goto.partner';
  }

  let thankyouTitle = (
    <FormattedHTMLMessage
      id="offer.submit.thankyoutitle"
      values={{
        firstName: authentication.firstName,
        lastName: authentication.lastName,
      }}
    />
  );

  if (isApproved) {
    thankyouTitle = <FormattedMessage id="offer.submit.thankyoutitle.approved" />;
  }

  if (INCREASE_APP) {
    thankyouTitle = <FormattedMessage id="offer.submit.thankyoutitle.increase" />;
  }

  const thankYouContent = (
    <>
      {emailPending && (
        <div className="loan-form__step-message loan-form__step-message--error">
          <div className="message message--error-small">
            <span className="message__icon" />
            <FormattedMessage id="offer.submit.email.confirm" />
          </div>
        </div>
      )}

      <div className="loan-form__step-body">
        <div className="thank-you">
          {!isApproved && (
          <h3 className="thank-you__text txt-center">
            <FormattedHTMLMessage id={thankYouText} />
          </h3>
          )}
          <div className="grid grid--center">
            {thankYouItems.map((item) => (
              <div key={item} className="grid__item eleven-twelfths">
                <ThankYouItem
                  title={<FormattedMessage id={`offer.submit.thankyou.${item}.title`} />}
                  info={<FormattedHTMLMessage id={`offer.submit.thankyou.${item}.text`} />}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className="loan-form__step">
      <p className="txt-center">
        <span className="icon icon--low icon--heart" />
      </p>
      <h1 className="loan-form__step-title loan-form__step-title--small loan-form__step-title__with_icon">
        {thankyouTitle}
      </h1>
      {thankYouContent}
      <div className="txt-center">
        <Button
          type="button"
          btnSize="wide"
          onClick={handleReturnLink}
        >
          <FormattedMessage id={btnOfferSuccessText} />
        </Button>
      </div>
    </div>
  );
};

ThankYouPage.propTypes = propTypes;

export default connect(null, { pushGaStepEvent })(ThankYouPage);
